


// import React, { useState } from 'react';
// import { Box, IconButton, AppBar, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import Sidebar from './Sidebar';
// import BytingKornerLogo from '../../assets/Byting_Korner_logo.png'; // Replace with your path

// const Layout = ({ children }) => {
//     const [mobileOpen, setMobileOpen] = useState(false);
//     const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//     return (
//         <Box sx={{ display: 'flex' }}>
//             {/* Show AppBar only on mobile */}
//             {isMobile && (
//                 <AppBar
//                     position="fixed"
//                     elevation={1} // ← reduce elevation from default (4)
//                     sx={{
//                         backgroundColor: '#1c1c1e', // match your dark sidebar if using dark theme
//                         color: '#fff',
//                         zIndex: (theme) => theme.zIndex.drawer + 1,
//                     }}
//                 >
//                     <Toolbar>
//                         <IconButton
//                             color="inherit"
//                             edge="start"
//                             onClick={handleDrawerToggle}
//                             sx={{ mr: 2 }}
//                         >
//                             <MenuIcon />
//                         </IconButton>
//                         <img
//                             src={BytingKornerLogo}
//                             alt="Byting Korner Logo"
//                             style={{ maxWidth: 180, maxHeight: 60, objectFit: 'contain' }}
//                         />
//                     </Toolbar>
//                 </AppBar>
//             )}

//             <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />

//             <Box
//                 component="main"
//                 sx={{
//                     flexGrow: 1,
//                     // p: 3,
//                     mt: isMobile ? 7 : 0, 
//                 }}
//             >
//                 {children}
//             </Box>
//         </Box>
//     );
// };

// export default Layout;






import React, { useState } from 'react';
import { Box, IconButton, AppBar, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar';
import BytingKornerLogo from '../../assets/Byting_Korner_logo.png';
import { Outlet, useLocation } from 'react-router-dom';


const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen((prev) => !prev);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const location = useLocation();
  const publicRoutes = ['/login', '/forgot-password', '/new-password', "/order-tracker/order-pos", "/order-tracker/orderoverview-pos","/manage-stock/requesthistory-pos", "/manage-stock/stockmanage-pos",
    
  ];
  const isPublicRoute = publicRoutes.includes(location.pathname);

   const user = JSON.parse(localStorage.getItem('userDetails')) || {};
  const userRole = user?.role_name;

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AppBar only for private routes on mobile */}
      {!isPublicRoute && isMobile && (
        <AppBar
          position="fixed"
          elevation={1}
          sx={{
            backgroundColor: '#1c1c1e',
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={BytingKornerLogo}
              alt="Byting Korner Logo"
              style={{ maxWidth: 180, maxHeight: 60, objectFit: 'contain' }}
            />
          </Toolbar>
        </AppBar>
      )}

      {/* Sidebar only for private routes */}
      {!isPublicRoute && (
        <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} userRole={userRole} />
      )}

      {/* Main content area */}
     <Box component="main" sx={{ flexGrow: 1, mt: !isPublicRoute && isMobile ? 7 : 0 }}>
  <Outlet />
</Box>

    </Box>
  );
};

export default Layout;
